import * as React from "react";
var useOnScreen = function (threshold, onlyOnce) {
    var _a = React.useState(null), elementRef = _a[0], setElementRef = _a[1];
    var _b = React.useState(false), isIntersecting = _b[0], setIntersecting = _b[1];
    React.useEffect(function () {
        var observer = new IntersectionObserver(function (_a, obs) {
            var entry = _a[0];
            var val = entry.isIntersecting;
            if (val && onlyOnce)
                obs.unobserve(entry.target);
            setIntersecting(val);
        }, { threshold: threshold });
        if (elementRef !== null) {
            observer.observe(elementRef);
        }
        else
            setIntersecting(false);
        return function () { observer.disconnect(); };
    }, [elementRef, onlyOnce]);
    return {
        visible: isIntersecting,
        setRef: setElementRef
    };
};
export default useOnScreen;
//# sourceMappingURL=useOnScreen.js.map